export function getScrollTop() {
  return window.pageYOffset
    ? window.pageYOffset
    : document.documentElement.clientHeight
    ? document.documentElement.scrollTop
    : document.body.scrollTop;
}

export function scrollToTop(duration: number = 0) {
  scrollToPos(0, duration).catch(err => console.error(err));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function scrollToTopOf(node: any, offset: number = 0, duration: number = 0): Promise<void> {
  if (!node) {
    return Promise.resolve();
  }

  const { top } = node.getBoundingClientRect();
  const scrollTop = getScrollTop();

  return scrollToPos(scrollTop + top + offset, duration);
}

export function scrollToPos(to: number, duration: number = 0): Promise<void> {
  if (!window.requestAnimationFrame || !duration) {
    // scroll without animation as fallback
    window.scrollTo(0, Math.round(to));

    return Promise.resolve();
  }

  const startTime = Date.now();
  const from = getScrollTop();

  return new Promise<void>(resolve => {
    // scroll looping over a frame
    function step() {
      const time = Date.now();
      let elapsed = (time - startTime) / duration;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      const value = 0.5 * (1 - Math.cos(Math.PI * elapsed));

      const currentPos = from + (to - from) * value;

      window.scrollTo(0, currentPos);

      // scroll more if we have not reached our destination
      if (currentPos !== to) {
        window.requestAnimationFrame(step);
      } else {
        resolve();
      }
    }

    step();
  });
}
